import { createContext } from 'react';

export const AlternativeProductsContext = createContext<boolean>(false);
